import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { getDropdownDataV1Service } from "../../services/studentService";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../actions/getUserData";
import { setAppLoader } from "../../actions/setAppLoader";
import { validEmail } from "../../custom-hooks/validRegex";
import { saveFormPath } from "../../services/userService";
import {
  matchAddress,
  saveResidentialData,
} from "../../services/userVerifications";
import CAlert from "../utils/CAlert";
import CButton from "../utils/CButton";
import CDialogue from "../utils/CDialogue";
import CInput from "../utils/CInput";
import CSelectBox from "../utils/CSelectBox";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import {
  saveStudentData,
  uploadFile,
  deleteFile,
} from "../../services/studentService";
import {
  faceVerify,
  saveFaceData,
} from "../../services/faceVerificationService";
import { saveAdditionalAddressDocuments } from "../../services/bankService";

export default function AadharOutputV1({ setTabValue, userDetailId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [isCurrentAddress, setIsCurrentAddress] = React.useState(false);
  const [aadharData, setAadharData] = React.useState([]);
  const [residentialStatus, setResidentialStatus] = React.useState("");
  const [residentialList, setResidentialList] = React.useState([]);
  const [isCurrenResident, setIsCurrentResident] = React.useState(false);
  const [showResidentialModal, setShowResidentialModal] = React.useState(false);
  const [noOfYears, setNoOfYears] = React.useState("");
  const [noOfYearsList, setNoOfYearsList] = React.useState([]);
  const [error, setError] = React.useState(false);
  const [addressMatch, setAddressMatch] = React.useState(false);
  const [faceNotMatch, setFaceNotMatch] = React.useState(false);
  const [faceMatched, setFaceMatched] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [profileImage, setProfileImage] = React.useState("");

  const [documentType, setDocumentType] = React.useState("");
  const [documentURL, setDocumentURL] = React.useState("");
  const [documentTypeList, setDocumentTypeList] = React.useState([]);
  const MAX_FILE_SIZE = 15000; // 15MB
  const [fileURL, setFileURL] = React.useState("");
  const [fileName, setFileName] = React.useState("");

  const inputRef = React.useRef(null);
  const dropDownData = useSelector((state) => state?.getDropDownData?.data);
  const userDetails = useSelector((state) => state?.getUserData?.data);
  const isFetching = useSelector((state) => state?.getUserData?.isFetching);
  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const userAadharImage = userDetails?.aadharDetails?.userImageId;
  const userFaceImage = userDetails?.faceImage;

  const disabledButton = (!addressMatch && !fileURL) || faceNotMatch;

  useEffect(() => {
    dispatch(getUserData(userDetailId));

    matchAddress(userDetailId).then((res) => {
      setAddressMatch((res.response ?? 0) > 50);
    });
  }, []);

  //Show Loader
  React.useEffect(() => {
    dispatch(setAppLoader(isFetching));
  }, [isFetching]);

  // set Aadhaar Data
  React.useEffect(() => {
    if (userDetails?.aadharDetails) {
      setAadharData(userDetails?.aadharDetails);
      setIsCurrentResident(userDetails?.aadharDetails?.isCurrentAddress);
      setResidentialStatus(
        userDetails?.aadharDetails?.userResidentialStatus?.valueId
      );
      setNoOfYears(
        userDetails?.aadharDetails?.userYearsAtCurrentResident?.valueId
      );
      setIsCurrentAddress(userDetails?.aadharDetails?.isCurrentAddress);
      const rawResp = JSON.parse(userDetails.aadharDetails.aadharResponse);
      setProfileImage(rawResp.data.aadhaar_xml_data.profile_image);
    }
  }, [userDetails]);

  React.useEffect(() => {
    async function fetchDropdownData() {
      // Filter Residential Status
      const fetchedDropDownData = await getDropdownDataV1Service();
      let docObj = fetchedDropDownData.find(
        (x) => x.keyDesc === "DOCUMENT_TYPE"
      );
      const tempDocData = [];
      docObj?.valueData?.map((eItem) => {
        tempDocData.push({
          value: eItem?.valueid,
          name: eItem?.valuedesc,
        });
      });
      setDocumentTypeList(tempDocData);
    }
    fetchDropdownData();
  }, []);

  // Save Aadhaar data
  async function onSubmitAadharOutput(e) {
    e.preventDefault();
    dispatch(setAppLoader(true));
    if (!addressMatch) {
      const additionalAddressData = {
        currentAddress: addressMatch,
        addtionalAddressId:
          userDetails?.userAddtionalAddressDetails?.addtionalAddressId,
        addtionalAddressTypeId: +documentType,
        addtionalAddressDocumentId: fileURL,
      };
      await saveAdditionalAddressDocuments(additionalAddressData);
    }

    dispatch(getUserData(userDetailId));

    // Automated face-match disabled: relying fully on manual review, skip straight to loan agreement.
    // const verifedImage = await faceVerify(
    //   userFaceImage,
    //   userAadharImage,
    //   userDetailId
    // );
    // const obj = {
    //   userInstituteDetailId: userDetailId,
    //   faceMatchScore:
    //     +verifedImage?.data?.result?.matchPercentage.split(".")[0],
    // };
    // await saveFaceData(obj);
    saveFormPath("/loanAgreement", userDetails?.detailId);
    setTabValue(8);
    navigate("/loanAgreement", {
      state: { tabValue: 9, stepperCount: 6, userDetailId: userDetailId },
    });
    dispatch(setAppLoader(false));
  }

  function handleBack() {
    setTabValue(5);
    navigate("/", {
      state: { tabValue: 5, stepperCount: 4, userDetailId: userDetailId },
    });
  }

  function onSameAddress(isSameAddress) {
    onSubmitAadharOutput(isSameAddress);
  }

  function onFileUpload() {
    setError(false);
    // 👇️ open file input box on click of other element
    inputRef.current.click();
  }

  function handleFileChange(event) {
    const fileObj = event.target.files && event.target.files[0];
    const extension = fileObj.name.split(".")[1];
    if (event.target.files.length > MAX_FILE_SIZE) {
      setError(true);
      setErrorMsg("File length should be less than 15Mb");
      return;
    }
    if (extension !== "pdf" && extension !== "PDF") {
      setError(true);
      setErrorMsg("Only PDF files are allowed");
      return;
    }
    setFileName(fileObj?.name);
    const formData = new FormData();
    formData.append("file", fileObj);
    formData.append("delimeter", userDetails?.user?.userName);
    formData.append("detailId", +localStorage.getItem("detailId"));
    uploadFile(formData).then((res) => {
      if (res?.status === 200) {
        setFileURL(res?.data);
      }
    });
  }

  // Delete uploaded file by fileURL
  async function deleteFileByURL() {
    await deleteFile(fileURL);
    setFileURL("");
  }

  return (
    <form
      onSubmit={(e) => onSubmitAadharOutput(e)}
      className="applicationFormContainer"
    >
      {error ? (
        <CAlert open={error} message={errorMsg} severity="error" />
      ) : null}
      {errorMsg === "Data Saved Successfully" ? (
        <CAlert open={true} message={errorMsg} severity="success" />
      ) : null}
      {!matches && (
        <Box sx={{ display: "flex" }}>
          <ArrowBackIosIcon onClick={() => handleBack()} />
        </Box>
      )}
      {
        matches ? (
          <Typography
            color="textColor"
            variant="subtitle1"
            sx={{ textAlign: "left", fontFamily: "lato", fontWeight: "bold" }}
          >
            Aadhar Output
          </Typography>
        ) : null
        // <Typography color='textColor' variant='subtitle3' sx={{ pb:4, fontWeight:"bold", textAlign: "center" }}>Aadhar Output</Typography>
      }
      <Grid
        container
        sx={{ pt: 2 }}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            Full Name
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userFullName}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            Address
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userAddress}
          </Typography>
        </Grid>

        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            Gender
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userGender}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            Date Of Birth
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userDob}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            PinCode
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userPincode}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            City
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userCity}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            District
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userDistrict}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            State
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {aadharData?.userState}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            Photograph
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Avatar
            sx={{ width: 100, height: 100 }}
            src={"data:image/png;base64," + profileImage}
            variant="square"
          ></Avatar>
        </Grid>
      </Grid>
      {!addressMatch && (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12}>
            <Typography
              color="textColor"
              variant="body2"
              sx={{
                textAlign: "start",
                fontWeight: "bold",
                fontSize: 24,
                marginTop: 5,
              }}
            >
              Aadhaar Address not current
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color="textColorR"
              variant="body2"
              sx={{ textAlign: "start", fontSize: 14 }}
            >
              Mismatch noted between address fetched through UIDAI & address
              entered during signup! Kindly upload an address proof for current
              residential address.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <CSelectBox
              onChange={setDocumentType}
              optionList={documentTypeList}
              defaultValue={documentType}
              label="Select Document Type*"
              name="documentType"
            />
          </Grid>
          <Grid
            item
            xs={6}
            container
            sx={{ pt: 4 }}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            {fileURL && (
              <Grid
                sx={{ display: "flex", alignItems: "center", gap: "5px" }}
                item
                xs={12}
              >
                <Typography
                  color="textColor"
                  variant="body2"
                  sx={{ textAlign: "left" }}
                >
                  {fileName}
                </Typography>
                <CloseIcon color="warning" onClick={deleteFileByURL} />
              </Grid>
            )}
            <Grid item xs={6}>
              <input
                accept="application/pdf"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
                ref={inputRef}
              />
              <Button
                onClick={onFileUpload}
                color="uploadButton"
                fullWidth
                variant="contained"
                startIcon={<FileUploadIcon />}
              >
                Upload
              </Button>
            </Grid>
            <Grid
              sx={{ display: "flex", alignItems: "center", gap: "5px" }}
              item
              xs={6}
            >
              {fileURL && (
                <React.Fragment>
                  <CheckCircleRoundedIcon color="success" />
                  <Typography
                    color="textColor"
                    variant="body2"
                    sx={{ textAlign: "left" }}
                  >
                    Upload Successful
                  </Typography>
                </React.Fragment>
              )}
            </Grid>
            <Grid sx={{ textAlign: "left" }} item xs={12}>
              <Typography
                color="textColorR"
                sx={{ fontWeight: "bold", textAlign: "left", fontSize: 12 }}
              >
                The uploaded file should be PDF should not exceed 15MB
              </Typography>
            </Grid>
            <Grid sx={{ textAlign: "left" }} item xs={12}>
              <Typography
                color="inputLabelColor"
                variant="aadharLabel"
                sx={{ fontWeight: "bold", textAlign: "left", fontSize: 12 }}
              >
                Note: The Uploaded document should have proof of the current
                address mentioned above.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      {faceNotMatch && (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} marginBottom={6}>
          <Grid item xs={12}>
            <Typography
              color="textColor"
              variant="body2"
              sx={{
                textAlign: "start",
                fontWeight: "bold",
                fontSize: 24,
                marginTop: 5,
              }}
            >
              Aadhaar Photo Mismatch with Selfie
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color="textColorR"
              variant="body2"
              sx={{ textAlign: "start", fontSize: 14 }}
            >
              Unfortunately, we couldn’t do a successful match between your selfie and aadhar photo. 
Kindly contact customer care on 8655873308
            </Typography>
          </Grid>
        </Grid>
      )}
      <div
        style={{
          padding: "20px 0px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: `${!matches ? "space-around" : "space-between"}`,
        }}
      >
        {matches && <CButton handleClick={() => handleBack()} name="Back" />}
        <Button
          type="submit"
          sx={{ fontStyle: "Lato" }}
          color="neutral"
          disabled={disabledButton}
          variant="contained"
        >
          Save & Submit
        </Button>
      </div>
      {showResidentialModal ? (
        <CDialogue
          open={showResidentialModal}
          setOpen={setShowResidentialModal}
          message="Is your current residential address same as your Aadhar address"
          isConfirm={onSameAddress}
        />
      ) : null}
    </form>
  );
}
